import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { EXTRA_MAX_UNITS_MESSAGE, messages } from "../../EditExtra/messages";
import { Controller, UseFormReturn } from "react-hook-form";
import { SelectGroup } from "../SelectGroup";
import React from "react";
import { FormType } from "../../EditExtra/types";

export function RateMaxUnitsInput({ control, disabled }: UseFormReturn<FormType> & { disabled: boolean }) {
  return <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <FormattedMessage {...messages.maxBookableUnits} />
    </FormLabel>
    <Col sm={3}>
      <Controller
        name="maxUnits"
        control={control}
        render={({ field }) => (
          <SelectGroup optionDisplay={EXTRA_MAX_UNITS_MESSAGE} disabled={disabled} {...field} />
        )}
      />
    </Col>
  </FormGroup>;
}